import { defineAction } from '~/prix'
import ruralEnvironmentalRegistryFetchAction from './ruralEnvironmentalRegistryFetch.action.json' with { type: 'json' }
import { z } from 'zod'
import { multiPolygon, point, polygon } from '~/prix/types/presets/geo'

const ruralEnvironmentalRegistryFetchDefinition = defineAction({
  ...ruralEnvironmentalRegistryFetchAction,

  input: z.object({
    municipalityId: z.number(),
  }),
  output: z.object({
    items: z.array(
      z.object({
        id: z.string(),
        carCode: z.string(),
        themeCode: z.string().nullish(),
        propertyName: z.string().nullish(),
        propertyType: z
          .enum(['rural_property', 'agrarian_reform', 'traditional_community'])
          .nullish(),
        totalArea: z.coerce.number().nullish(),
        fiscalModule: z.coerce.number().nullish(),
        registrationStatus: z.enum(['active', 'pending', 'suspended', 'cancelled']).nullish(),
        registrationCondition: z
          .enum([
            'analyzed_awaiting_notification',
            'awaiting_analysis',
            'analyzed_automatic_filter',
            'analyzed_compliant',
            'analyzed_no_pending',
            'under_analysis',
            'cancelled_judicial_decision',
            'cancelled_duplicity',
            'cancelled_administrative_decision',
          ])
          .nullish(),
        registrationDate: z.string().nullish(),
        lastUpdateDate: z.string().nullish(),
        municipalityId: z.number(),
        microRegionId: z.number().nullish(),
        mesoRegionId: z.number().nullish(),
        stateId: z.number().nullish(),
        macroRegionId: z.number().nullish(),
        countryId: z.number().nullish(),
        createdAt: z.string().nullish(),
        updatedAt: z.string().nullish(),
        deletedAt: z.string().nullish(),
        shape: z.union([polygon(), multiPolygon()]).nullish(),
        point: point().nullish(),
        key: z.string(),
      }),
    ),
  }),
})

export default ruralEnvironmentalRegistryFetchDefinition
